import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../config';

// Personal invite link + friend code lines appended to every shared text.
export const getInviteLines = async () => {
  const d = await axios.get(`${API}/referral/me`).then((r) => r.data).catch(() => null);
  if (!d?.invite_link) return '';
  return `\nIscriviti con il mio invito:\n${d.invite_link}\n\nUsa il mio codice: ${d.code}`;
};

// Tag on shared links: signups arriving through them are counted in the admin (campaign = where the tap was)
export const shareUtm = (campaign) => `utm_source=rvincente_share&utm_medium=share&utm_campaign=${campaign}`;

// Invite text with the sharer's code; the link carries the share tag
export const inviteShareText = async (campaign) => {
  const d = await axios.get(`${API}/referral/me`).then((r) => r.data).catch(() => null);
  if (!d?.invite_link) return null;
  const tagged = `${d.invite_link}${d.invite_link.includes('?') ? '&' : '?'}${shareUtm(campaign)}`;
  return d.share_text.split(d.invite_link).join(tagged);
};

// Logs a Condividi tap (screen: invite | multipla | selezione | analisi | nudge).
export const trackShare = (screen) => { axios.post(`${API}/referral/share-event`, { screen }).catch(() => {}); };

// Text-only share sheet (native → Web Share → clipboard).
export const shareText = async (text, dialogTitle = 'Condividi') => {
  try {
    const { Capacitor } = await import('@capacitor/core');
    if (Capacitor.isNativePlatform()) {
      const { Share } = await import('@capacitor/share');
      await Share.share({ text, dialogTitle });
      return;
    }
    if (navigator.share) { await navigator.share({ text }); return; }
    await navigator.clipboard.writeText(text);
    toast.success('Testo copiato: incollalo dove vuoi!');
  } catch { /* user cancelled */ }
};
